module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("6")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIDGIE,")]), _vm._v("” I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SAY TO MY SISTER")]), _vm._v(" on one of my trips. “May I raise a sensitive subject?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What could possibly be sensitive?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you and Tibor okay?” I ask. “I mean, moneywise. This has all got to be something of a strain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bridget looks at me with that blank face I am so used to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We’re okay,” she says, and leaves the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was a teenager when I left South Africa. I arrived in Boston without the right papers and in the dead of winter and struggled for years to find my footing, but those days are long gone. Tesseba and I live in a gracious house west of Boston, and while we do not live lavishly, this is a matter of choice. Bridget and Tibor, on the other hand, have never had money. You could say that they have never wanted money, but an outsider can never be too sure of things like that. In the early days, as I found my feet and worked my way up the business ladder, my sister seemed to become particularly vigilant not to let any balance be tipped by this, by the growing disparity in our circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was an uphill battle. My mother, when she was still a frequent visitor to Boston with Arnold in tow, used to make the invidious comparison relentlessly.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“You and Tibor live on the smell of an oil rag,” she used to say and Bridget, hearing her say it, would seem not to hear, would let the words drop away as if the comment had somehow not been made at ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("all. “It makes me sick, watching you struggle when my father’s money sits in South Africa doing as much good as a "), _c('em', [_vm._v("toytn bankes.")]), _vm._v("”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And that was the odd part of it, that this apparition of wealth had followed us to Boston, no more real or useful or accessible than ever, but almost a generation later continuing to haunt us.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9e0041","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013_Chapter06.vue
// module id = 99
// module chunks = 0